import React, { Component } from "react";
import RichTextEditor from "Projects/CC_cubi_clan_project/GlobalComponents/RichTextEditor/RichTextEditor";

/**
 * Sinopsis (editor rico).
 * Props:
 *  - html: string
 *  - onHtmlChange(html)
 */
export default class SynopsisSection extends Component {
  static defaultProps = {
    html: "",
  };

  render() {
    const { html, onHtmlChange } = this.props;
    return (
      <div className="mb-4 synopsis-section">
        <h3 className="project-subtitle">Sinopsis</h3>
        <RichTextEditor initialHtml={html} onChangeHtml={onHtmlChange} appCode="MUGIN" />
      </div>
    );
  }
}
